import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const AddressTypeTabs = lazy(() => import('./AddressTypeTabs'/* webpackChunkName: 'AddressTypeTabs' */));

export default function AddressTypeTabsLazyLoader(props) {
  return (
    // Following disable is to allow an empty fragment which we need to allow a 'blank' fallback
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <GenericFallbackSuspense fallback={<></>}>
      <AddressTypeTabs {...props} />
    </GenericFallbackSuspense>
  );
}
